const SEPARATORS = ['/', '.', ':'];

export function splitForMiddleTruncation(
  text: string,
  opts: { maxTailChars?: number; minSplitLength?: number; fallbackTailChars?: number } = {},
): { head: string; tail: string } {
  const { maxTailChars = 32, minSplitLength = 24, fallbackTailChars = 16 } = opts;
  if (text.length <= minSplitLength) {
    return { head: text, tail: '' };
  }

  const idx = Math.max(...SEPARATORS.map((separator) => text.lastIndexOf(separator)));
  const tailLength = text.length - idx;
  if (idx > 0 && tailLength > 1 && tailLength <= maxTailChars + 1) {
    return { head: text.slice(0, idx), tail: text.slice(idx) };
  }

  return { head: text.slice(0, -fallbackTailChars), tail: text.slice(-fallbackTailChars) };
}

export function elideCommonPrefix(
  names: string[],
  opts: { minPrefixChars?: number } = {},
): { prefix: string; rest: string[] } {
  const { minPrefixChars = 12 } = opts;
  const noElision = { prefix: '', rest: [...names] };
  if (names.length < 2) {
    return noElision;
  }

  let commonPrefix = names[0];
  for (const name of names.slice(1)) {
    let i = 0;
    while (i < commonPrefix.length && i < name.length && commonPrefix[i] === name[i]) {
      i += 1;
    }
    commonPrefix = commonPrefix.slice(0, i);
  }

  if (names.some((name) => name === commonPrefix)) {
    return noElision;
  }

  const idx = Math.max(...SEPARATORS.map((separator) => commonPrefix.lastIndexOf(separator)));
  if (idx < minPrefixChars) {
    return noElision;
  }

  const rest = names.map((name) => name.slice(idx));
  if (rest.some((suffix) => suffix.length <= 1)) {
    return noElision;
  }

  return { prefix: commonPrefix.slice(0, idx), rest };
}
